// @flow
import { handleActions } from 'redux-actions';

import {
  ADD_PAYMENT_METHOD,
  ADD_PAYMENT_METHOD_SUCCESS,
  ADD_PAYMENT_METHOD_FAILURE,
  GET_CARD_TOKEN,
  GET_CARD_TOKEN_SUCCESS,
  GET_CARD_TOKEN_FAILURE,
  INIT_OWNER,
  GET_OWNER_DETAILS,
  GET_OWNER_DETAILS_SUCCESS,
  GET_OWNER_DETAILS_FAILURE,
  REGISTER_OWNER,
  REGISTER_OWNER_SUCCESS,
  REGISTER_OWNER_FAILURE,
  ADD_ADDRESS,
  ADD_ADDRESS_SUCCESS,
  ADD_ADDRESS_FAILURE,
  LOGIN_SUCCESS,
  GET_WAG_TAG_GENERAL_INFO_SUCCESS,
} from '../../actions/actionTypes';

const initialState = {
  id: null,
  token: '',
  email: '',
  firstName: '',
  lastName: '',
  phone: '',
  stripeCardToken: '',
  streetAddress: {
    address: '',
    apt: '',
    state: '',
    zipcode: '',
  },
  isNew: false,
  trialEligibility: {
    isEligible: false,
    trialType: null,
  },
};

export const owner = handleActions(
  {
    [INIT_OWNER]: (state, {
      payload: {
        id,
        token,
      },
    }) => (
      {
        ...state,
        id,
        token,
        isNew: false,
      }
    ),
    [GET_OWNER_DETAILS]: state => (
      {
        ...state,
      }
    ),
    [GET_OWNER_DETAILS_SUCCESS]: (state, {
      payload: {
        email,
        phone,
        first_name: firstName,
        last_name: lastName,
        address,
        apt,
        state: addressState,
        zipcode,
      },
    }) => (
      {
        ...state,
        email,
        phone,
        firstName,
        lastName,
        streetAddress: {
          address,
          apt,
          state: addressState,
          zipcode,
        },
      }
    ),
    [GET_OWNER_DETAILS_FAILURE]: state => (
      {
        ...state,
      }
    ),
    [REGISTER_OWNER]: (state, {
      payload: {
        agreedToTerms,
        email,
        firstName,
        lastName,
        phone,
      },
    }) => ({
      ...state,
      agreedToTerms,
      email,
      firstName,
      lastName,
      phone,
    }),
    [REGISTER_OWNER_SUCCESS]: (state, {
      payload: {
        id,
        token,
      },
    }) => (
      {
        ...state,
        id,
        token,
        isNew: true,
      }
    ),
    [REGISTER_OWNER_FAILURE]: state => (
      {
        ...state,
      }
    ),
    [ADD_ADDRESS]: state => (
      {
        ...state,
      }
    ),
    [ADD_ADDRESS_SUCCESS]: (state, action) => (
      {
        ...state,
        streetAddress: {
          address: action.payload.owner.address,
          apt: action.payload.owner.apt,
          state: action.payload.owner.state,
          zipcode: action.payload.owner.zipcode,
        },
      }
    ),
    [ADD_ADDRESS_FAILURE]: state => (
      {
        ...state,
      }
    ),
    [GET_CARD_TOKEN]: state => (
      {
        ...state,
      }
    ),
    [GET_CARD_TOKEN_SUCCESS]: (state, action) => (
      {
        ...state,
        stripeCardToken: action.payload.token.id,
      }
    ),
    [GET_CARD_TOKEN_FAILURE]: state => (
      {
        ...state,
      }
    ),
    [ADD_PAYMENT_METHOD]: state => (
      {
        ...state,
      }
    ),
    [ADD_PAYMENT_METHOD_SUCCESS]: state => (
      {
        ...state,
      }
    ),
    [ADD_PAYMENT_METHOD_FAILURE]: state => (
      {
        ...state,
      }
    ),
    [LOGIN_SUCCESS]: (
      state,
      {
        payload: {
          token,
          ownerID: id,
        },
      },
    ) => (
      {
        // A brand new owner data (this will reset the owner data in Redux)
        ...initialState,
        id,
        token,
      }
    ),
    [GET_WAG_TAG_GENERAL_INFO_SUCCESS]: (state, {
      payload: {
        trial_eligibility: trialEligibility,
      },
    }) => {
      // User is in Activation Flow, where trial_eligibility is returned from API response
      if (trialEligibility) {
        const {
          is_eligible: isEligible,
          trial_type: trialType,
        } = trialEligibility;

        return {
          ...state,
          trialEligibility: {
            isEligible,
            trialType,
          },
        };
      }

      // User is on Wag Tag Order Page, where trial_eligibility is omitted from API response
      return {
        ...state,
      };
    },
  },
  initialState,
);
